import React, { useState, useEffect } from 'react';
import { Select } from 'antd';

import PageLayout from '../../components/PageLayout';
import useIsMobile from '../../hooks/useIsMobile';
import ActionLoader from '../../components/ActionLoader';
import Table from '../../components/Table';
import Modal from '../../components/Modal';
import Toast from '../../components/Toast';
import SettlementPDF from './SettlementPDF';
import Button from '../../components/Button';
import FormInput from '../../components/FormInput';
import { getLoginDetails } from '../../utils/storage';

import HeaderIconSvg from '../../icons/newicons/arrow-down-up.svg';
import SearchIconWhite from '../../icons/rev_find.png';
import AddSettlement from '../../icons/rev_add_invoice.png';

import {
  GET_ALL_SETTLEMENT_URL,
  EDIT_SETTLEMENT_URL,
  getData,
  putData,
  GET_FACILITIES_URL,
  GET_ENTITIES_URL,
} from '../../utils/api';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Settlement = (props) => {
  const isMobile = useIsMobile();

  const [isLoading, setIsLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [listItems, setListItems] = useState([]);
  const [params, setParams] = useState({
    limit: 10,
    offset: 0,
    areMoreItemsAvailable: false,
  });
  const [printPopup, setPrintPopup] = useState(null);
  const [isCreateSettlementClicked, setIsCreateSettlementClicked] =
    useState(false);
  const [facilities, setFaciltiesItems] = useState([]);
  const [customer, setCustomer] = useState('');
  const [entitiesItems, setEntitiesItems] = useState([]);
  const [showDropdownDiv, setShowDropdownDiv] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [toastParams, setToastParams] = useState({
    type: '',
    message: '',
    id: '',
  });
  const [reopenItem, setReopenItem] = useState(null);

  const getEntities = async (text, isFranchise = false) => {
    try {
      const data = await getData(GET_ENTITIES_URL, {
        count: 500,
        offset: 0,
        text,
        parentCompanyId: getLoginDetails().parentCompanyId,
        isEmbed: false,
        isFranchise,
        // customerSort: 'asc'
      });
      setEntitiesItems(data.list);
    } catch (e) {
      console.log('ERROR', e);
    }
  };

  const getFacilities = async () => {
    try {
      const data = await getData(GET_FACILITIES_URL, {
        count: 100,
        offset: 0,
        parentCompanyId:
          props.parentCompanyId || getLoginDetails().parentCompanyId,
      });
      setFaciltiesItems(
        (data.list && data.list.filter((el) => el.isActive)) || []
      );
    } catch (e) {}
  };

  useEffect(() => {
    getFacilities();
  }, []);

  const tableColumns = () => {
    const columns = [
      'Settlement No',
      'Shipment No',
      'Company Name',
      'facility',
      'Created Date',
      'MDD',
      'Received Date',
      'Completed Date',
    ];
    return columns.filter((item) => item !== '');
  };

  const tableKeys = () => {
    const keys = [
      'settlementNo',
      'shipmentNo',
      'companyName',
      'facilityCity',
      'created_Date',
      'metal_Due_Date',
      'received_Date',
      'completed_Date',
    ];
    return keys.filter((item) => item !== '');
  };

  const resetData = () => {
    setStartDate(null);
    setEndDate(null);
  };

  const getListData = async () => {
    const startDt = new Date(startDate ? startDate : Date.now()).setHours(
      0,
      0,
      0,
      0
    );
    const endDt = new Date(endDate ? endDate : Date.now()).setHours(
      23,
      59,
      59,
      59
    );
    try {
      setListItems([]);
      const payload = {
        count: params.limit,
        offset: params.offset,
        from: startDt,
        to: endDt,
        type: window.location.pathname.includes('open') ? 1 : 2,
      };
      const data = await getData(GET_ALL_SETTLEMENT_URL, payload);
      setIsLoading(false);
      setTableLoading(false);
      setListItems(data.list);
      setParams({
        ...params,
        areMoreItemsAvailable: data.areMoreItemsAvailable,
      });
    } catch (e) {
      console.log('ERROR', e);
    }
  };

  useEffect(() => {
    getListData();
  }, [window.location.pathname, params.offset, params.limit]);

  const hendelUserSelect = (item) => {
    const url = `/settlement/${
      props.match.path.includes('completed') ? 'completed' : 'open'
    }/create`;
    props.history.push(`${url}/${item ? item.settlementId : 'new'}`, {
      settledView: props.match.path,
      selectedCustomer: {
        companyId: selectedItem?.companyId || item?.companyId,
        companyName: selectedItem?.companyName || item?.companyName,
        facilityCity: selectedItem?.facilityCity || item?.facilityCity,
      },
      item,
    });
  };

  const fetchMore = () => {
    setParams({
      ...params,
      offset: params.offset + params.limit,
    });
  };
  const fetchLess = () => {
    setParams({
      ...params,
      offset: params.offset - params.limit,
    });
  };

  const showPrintPopup = (item) => {
    setPrintPopup(item);
  };

  const handleReopenSettlement = (item) => {
    setReopenItem(item);
  };

  const confirmReopenSettlement = async () => {
    if (!reopenItem) return;

    try {
      setTableLoading(true);
      setReopenItem(null);
      await putData(
        `${EDIT_SETTLEMENT_URL}?settlementId=${reopenItem.settlementId}`
      );
      setToastParams({
        type: 'SUCCESS',
        message: 'Settlement moved back to Open',
        id: new Date().getTime(),
      });
      await getListData();
    } catch (e) {
      console.log('ERROR reopening settlement', e);
      setToastParams({
        type: 'ERROR',
        message:
          (e && e.response && e.response.data && e.response.data.error) ||
          (e && e.error) ||
          'Failed to move settlement to Open',
        id: new Date().getTime(),
      });
      setTableLoading(false);
    }
  };

  return (
    <PageLayout
      icon={HeaderIconSvg}
      heading='Settlement'
      searchPlaceholder='Search Settlement'
    >
      {isLoading ? (
        <div className='ht-80 p-relative'>
          <ActionLoader />
        </div>
      ) : (
        <>
          <div
            className={`costSheetFilters settlementFilters ${
              isMobile ? 'mobile-view gap-3' : ''
            }`}
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
            }}
          >
            <div
              style={{
                paddingLeft: isMobile ? '0px' : '30px',
                width: isMobile ? '100%' : 'auto',
              }}
            >
              <div className='c-gray fs-12'> Start Date </div>
              <DatePicker
                selected={startDate ? startDate : Date.now()}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                className='form-control'
              />
            </div>
            <div
              style={{
                paddingLeft: isMobile ? '0px' : '50px',
                width: isMobile ? '100%' : 'auto',
              }}
            >
              <div className='c-gray fs-12'> End Date </div>
              <DatePicker
                selected={endDate ? endDate : Date.now()}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                className='form-control'
              />
            </div>
            <div style={{ display: 'flex' }}>
              <div className='search-button '>
                <div
                  className='wt-35 ht-35 rounded-circle  align-center d-flex justify-content-center align-items-center searchicon pl-4 pr-4 pb-8 pt-8 c-white fw-bolder c-pointer'
                  style={{ marginTop: '15px', marginLeft: '27px' }}
                  onClick={() => {
                    getListData();
                  }}
                >
                  <img
                    src={SearchIconWhite}
                    alt='searchicon'
                    width='20px'
                    height='20px'
                  />
                </div>
              </div>
              <div className='search-button'>
                <div
                  className='wt-35 ht-35 rounded-circle  align-center d-flex justify-content-center align-items-center  closeicon pl-4 pr-4 pb-8 pt-8 c-white fw-bolder c-pointer'
                  onClick={() => {
                    resetData();
                  }}
                  style={{ marginTop: '15px', marginLeft: '27px' }}
                >
                  <span className='fs-16 c-white'> X </span>
                </div>
              </div>
              <div className='search-button'>
                <div
                  className='wt-35 ht-35 rounded-circle  align-center d-flex justify-content-center align-items-center  searchicon pl-4 pr-4 pb-8 pt-8 c-white fw-bolder c-pointer'
                  onClick={() => {
                    // hendelUserSelect(null);
                    setIsCreateSettlementClicked(true);
                  }}
                  style={{ marginTop: '15px', marginLeft: '27px' }}
                >
                  <img
                    src={AddSettlement}
                    alt='searchicon'
                    width='20px'
                    height='20px'
                  />
                </div>
              </div>
            </div>
          </div>
          {listItems.length === 0 && (
            <div className='fs-18 flex flex-center wt-100p mt-24 mb-24 c-gray'>
              {`No ${
                props.match.path.includes('completed') ? 'Completed' : 'Open'
              } Settlement`}
            </div>
          )}
          {listItems.length > 0 && (
            <Table
              scrollTable={true}
              highlight={true}
              columns={tableColumns()}
              modalColumn={['message']}
              items={listItems.map((load, index) => {
                const createdDate = new Date(
                  load.createdDate || load.updatedDate
                );

                const metalDueDate = new Date(load.metalDueDate);

                const receivedDate = new Date(load.receivedDate);

                const completedDate = new Date(load.completedDate);

                return {
                  ...load,
                  metal_Due_Date: load.metalDueDate
                    ? `${String(metalDueDate.getMonth() + 1).padStart(
                        2,
                        '0'
                      )}-${String(metalDueDate.getDate()).padStart(
                        2,
                        '0'
                      )}-${metalDueDate.getFullYear()}`
                    : '',
                  created_Date:
                    load.createdDate || load.updatedDate
                      ? `${String(createdDate.getMonth() + 1).padStart(
                          2,
                          '0'
                        )}-${String(createdDate.getDate()).padStart(
                          2,
                          '0'
                        )}-${createdDate.getFullYear()}`
                      : '',
                  received_Date: load.receivedDate
                    ? `${String(receivedDate.getMonth() + 1).padStart(
                        2,
                        '0'
                      )}-${String(receivedDate.getDate()).padStart(
                        2,
                        '0'
                      )}-${receivedDate.getFullYear()}`
                    : '',
                  completed_Date: load.completedDate
                    ? `${String(completedDate.getMonth() + 1).padStart(
                        2,
                        '0'
                      )}-${String(completedDate.getDate()).padStart(
                        2,
                        '0'
                      )}-${completedDate.getFullYear()}`
                    : '',
                };
              })}
              keys={tableKeys()}
              widthClasses={[
                'wt-140',
                'flex-1',
                'flex-1',
                'flex-1',
                'flex-1',
                'flex-1',
                'wt-100',
              ]}
              actions={
                props.match.path.includes('completed')
                  ? ['PRINT', 'REOPEN']
                  : false
              }
              onPrint={showPrintPopup}
              onReopen={handleReopenSettlement}
              hideCheckBox={true}
              onItemClick={hendelUserSelect}
              isLoading={tableLoading}
              offset={params.offset}
              areMoreItemsAvailable={params.areMoreItemsAvailable}
              onCountChange={(value) => {
                setParams({
                  ...params,
                  offset: 0,
                  limit: value,
                });
              }}
              fetchMore={fetchMore}
              fetchLess={fetchLess}
              limit={params.limit}
            />
          )}
        </>
      )}
      {Object.keys(printPopup || {}).length > 0 && (
        <Modal>
          <SettlementPDF
            setPrintPopup={setPrintPopup}
            itemData={printPopup}
            hidePreview={true}
          />
        </Modal>
      )}
      {isCreateSettlementClicked && (
        <Modal>
          <div
            className={`pt-10 pb-20 pl-10 pr-10 ${
              isMobile ? 'wt-320' : 'wt-600 ht-200'
            }`}
          >
            <div className='flex flex-middle mr-12 pb-20'>
              <h1 className='mr-24 fs-20 c-black fw-bolder'>
                CREATE SETTLEMENT
              </h1>
            </div>

            <div className='flex flex-middle mb-24 mt-10'>
              <span className='c-gray mr-4 wt-30p'> CUSTOMER: </span>
              <div className={`customer-filter w-100`}>
                <div className='mb-16'> </div>
                <div className=' p-relative '>
                  <input
                    value={customer}
                    className=' form-control top_form_input forminput fs-16  ht-35 search'
                    placeholder='Customer Filter'
                    onChange={(e) => {
                      setCustomer(e.target.value);
                      if (e.target.value.length === 0) {
                        setSelectedItem('');
                        getEntities('');
                        setShowDropdownDiv(false);
                      }
                      if ((e.target.value || '').length > 2) {
                        setCustomer(e.target.value);
                        getEntities(e.target.value);
                        setShowDropdownDiv(true);
                      }
                    }}
                  />

                  {showDropdownDiv && entitiesItems.length > 0 && (
                    <div className='p-absolute z-1 border-black w-100'>
                      <div
                        className='pl-8 pr-8 bg-lt-gray z-1 max-ht-100'
                        style={{ overflow: 'scroll' }}
                      >
                        {[...entitiesItems].map((item) => {
                          return (
                            <div
                              key={item.companyId}
                              className='flex selectListDiv c-pointer'
                              onClick={() => {
                                setShowDropdownDiv(false);
                                setEntitiesItems([]);
                                setSelectedItem(item);
                                setCustomer(item.companyName);
                              }}
                            >
                              <div className='fs-14 mb-4'>
                                {item.companyName}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='flex flex-middle mb-24 mt-10'>
              <span className='c-gray mr-4 wt-30p'> LOCATION: </span>
              <select
                name='type'
                className='bg-blue rounded-pill select font-primary fs-14 fw-bolder '
                value={selectedItem.facilityCity}
                onChange={(e) =>
                  setSelectedItem({
                    ...selectedItem,
                    facilityCity: e.target.value,
                  })
                }
              >
                <option value={''}>SELECT FACILITY</option>
                {facilities.map((state) => {
                  return <option value={state.name}>{state.name}</option>;
                })}
              </select>
            </div>
            <div
              className='flex flex-middle flex-right pt-25 wt-200'
              style={{ float: 'right' }}
            >
              <Button
                type='modalCancel'
                className='btn ht-40 btn-red flex flex-middle mr-20 bg-red'
                onClick={() => {
                  setIsCreateSettlementClicked(false);
                }}
              >
                <span>CANCEL</span>
              </Button>
              <Button
                type='modalSave'
                className='btn ht-40 flex flex-middle'
                disabled={
                  Object.keys(selectedItem).length === 0 ||
                  !selectedItem.hasOwnProperty('facilityCity') ||
                  selectedItem?.facilityCity == ''
                }
                onClick={() => {
                  hendelUserSelect(null);
                }}
              >
                <span>{'SAVE'}</span>
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {reopenItem && (
        <Modal>
          <div className='pl-16 pr-16'>
            <div className='fs-18 fw-bolder t-center mb-20'>
              {`Are you sure you want to move settlement ${
                reopenItem.settlementNo || ''
              } back to Open?`}
            </div>
            <div className='flex flex-middle flex-center'>
              <Button
                className='mr-20'
                type='secondary'
                onClick={() => setReopenItem(null)}
              >
                Cancel
              </Button>
              <Button type='modalSave' onClick={confirmReopenSettlement}>
                Confirm
              </Button>
            </div>
          </div>
        </Modal>
      )}
      <Toast
        type={toastParams.type}
        message={toastParams.message}
        id={toastParams.id}
      />
    </PageLayout>
  );
};

export default Settlement;
